import { $ } from '../util/view';
export default function render({ body, footer, headerLevel = 2, title }) {
    const view = ($('div', { class: 'mol-ads-cmp--modal' }, [
        $('div', { class: 'mol-ads-cmp--modal-dialog' }, [
            $('div', { class: 'mol-ads-cmp--modal-content' }, [
                $('div', { class: 'mol-ads-cmp--modal-header' }, [
                    $(`h${headerLevel}`, { class: 'mol-ads-cmp--modal-title' }, title),
                ]),
                $('div', { class: 'mol-ads-cmp--modal-body' }, body),
                $('div', { class: 'mol-ads-cmp--modal-footer' }, footer)
            ])
        ])
    ]));
    return Object.assign(view, { close: () => view.remove() });
}
